import { AxiosResponse } from 'axios'

import { ProperNoun } from 'types/properNoun'

import { _axios } from './axios'

const ALL = `/proper-nouns`
const FIND_BY_ID = (id: string) => `/proper-nouns/${id}`
const ADD = `/proper-nouns`
const EDIT = (id: string) => `/proper-nouns/${id}`
const REMOVE = (id: string) => `/proper-nouns/${id}`

export const properNounApi = () => {
  const getAll = async (): Promise<AxiosResponse<ProperNoun[]>> => {
    return await _axios()
      .get(ALL)
      .then((res) => {
        res.data = res.data.properNouns
        return res
      })
  }

  const findById = async (id: string): Promise<AxiosResponse<ProperNoun>> => {
    return await _axios()
      .get(FIND_BY_ID(id))
      .then((res) => {
        res.data = res.data.properNoun
        return res
      })
  }

  const add = async (
    data: Omit<ProperNoun, 'id'>,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(ADD, data)
  }

  const edit = async (
    id: string,
    data: Omit<ProperNoun, 'id'>,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().put(EDIT(id), data)
  }

  const remove = async (id: string): Promise<AxiosResponse<void>> => {
    return await _axios().delete(REMOVE(id))
  }

  return {
    getAll,
    findById,
    add,
    edit,
    remove,
  }
}
